// category → badge color for receiver marketplace cards
// colors chosen for contrast on both dark (#2a2a2a) and light (#f7f7f7) backgrounds
// avoids collision with receiver blue (#2196F3) and vrtta green (#669d2e)
const CATEGORY_COLORS = {
  Plastics: "#2563eb",
  Metals: "#6b7280",
  Paper: "#d97706",
  Glass: "#0d9488",
  Wood: "#92400e",
  Textiles: "#7c3aed",
  Rubber: "#374151",
  Chemicals: "#dc2626",
  Organics: "#16a34a",
  Electronics: "#0891b2",
};

const FALLBACK_COLOR = "#6b7280";

export const getCategoryColor = (category) =>
  CATEGORY_COLORS[category] || FALLBACK_COLOR;

export default CATEGORY_COLORS;
